// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__2n876"};